module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RecordListView.js"));
	}, "PunishRecordListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PunishRecordListView!./src/pages/Promote/BusinessHall/Punish/RecordList/RecordListView.js
// module id = 2081
// module chunks = 367